import request, { extend } from 'umi-request';
import React from 'react'
import { message } from 'antd';
import $config from '@/config';
import cookie from 'react-cookies'
import qs from 'qs'
const md5 = require('md5');

let configBaseUrl = '';
let code = 0
switch (process.env.NODE_ENV) {
    case 'development':
        // 这里是本地的请求url
        configBaseUrl = $config.apiUrl.dev
        break
    case 'production':
        // 生产环境url
        configBaseUrl = $config.apiUrl.pro
        break
    default:
        configBaseUrl = ''
        break;
}

const errorHandler = (error) => {
    // 请求已发送但服务端返回状态码非 2xx 的响应
    if (error.response) {
        if (error.data.code === 500) {
            // 跳转至至指定500页面
            // history.push('/500');
        }else if (error.data.code === 404) {
            // 跳转至至指定404页面
            // history.push('/404');
        }else {
            // 若不是500或404，则展示异常message
            message.error(error.data.message ? error.data.message : error.data);
        }
    } else {
        // 请求初始化时出错或者没有响应返回的异常
        if (window.location.pathname.lastIndexOf('#/login') !== -1) {
            message.error('系统错误')
            return false
        } else {
            message.error('系统错误')
            return false
        }
    }
}

// 响应拦截器
// 克隆响应对象做解析处理
request.interceptors.response.use(async response => {
    const data = await response.clone().json();
    // 详情返回的response处理
    if (data.code !== 0){
        let msg = '';
        if(data.message && data.message !== '' && data.code !== 2000){
            msg = data.message
        }else {
            const url = window.location.href.split('#')[0]
            switch (data.code) {
                case 401:
                    msg = '您的登录状态已过期，请重新登录'
                    code = code === 0 ? 1 : 2
                    if(React.$socket) {
                        React.$socket.close()
                    }
                    cookie.remove('user_token');
                    setTimeout(() => {
                        code = 0
                        window.location.href = url +'#/login'
                    }, 1000);
                    break
                case 1000:
                    msg = `${data.message}`
                    break;
                case 1002:
                    // 验证码错误或验证码已过期提示，弹出提示
                    msg = ''
                    break;
                case 2000:
                    msg = '登录已过期';
                    code = code === 0 ? 1 : 2
                    if(React.$socket) {
                        React.$socket.close()
                    }
                    cookie.remove('user_token')
                    if(window.location.href.split('#')[1].indexOf('singleLogin') === -1) {
                        setTimeout(() => {
                            code = 0
                            window.location.href = url + '#/login'
                        }, 1000);
                    }
                    break
                case 2014:
                    msg = data.message;
                    cookie.remove('user_token')
                    code = code === 0 ? 1 : 2
                    if(window.location.href.split('#')[1].indexOf('singleLogin') === -1) {
                        setTimeout(() => {
                            code = 0
                            window.location.href = url + '#/login'
                        }, 1000);
                    }
                    break
                case 2001:
                    msg = '无效的作用域';
                    break
                case 2002:
                    msg = '无效的请求';
                    break
                case 2003:
                    msg = '无效的客户端';
                    break
                case 2004:
                    msg = '无效的授权';
                    break
                case 2006:
                    msg = '未经授权的客户端';
                    break
                case 2008:
                    msg = '不支持的授权类型';
                    break
                case 2009:
                    msg = '不支持的响应类型';
                    break
                case 2013:
                    msg = '签名不正确';
                    break
                case 4007:
                    msg = '入参异常，拒绝访问';
                    break
                case 4000:
                    msg = '不支持的请求类型';
                    break
                case 5000:
                    msg = '系统错误';
                    break
                case 4030 :
                    code = code === 0 ? 1 : 2
                    msg = '权限不足，拒绝访问';
                    setTimeout(() => {
                        code = 0
                    }, 2000);
                    break
                case 4004:
                    msg = '访问地址不存在';
                    break;
                default:
                    msg = (data.message && data.message !== '') ? data.message : '服务器错误';
                    break;
            }
        }
        if(msg && code === 1) {
            code = 2
            message.error(msg);
        }else if(msg && code === 0){
            message.error(msg);
        }
    }
    return response;
});

// 请求拦截器, 改变url 或 options.
request.interceptors.request.use((url, options) => {
    if (url.indexOf('/auth/login') === -1 &&  url.indexOf('/auth/rsaPublicKey') === -1 && url.indexOf('/vcc/code') === -1 && url.indexOf('/vcc/verify') === -1) {
        options = {
            ...options,
            headers :{
                ...options.headers,
                Authorization: `${cookie.load('user_token')}`
            }
        }
    }
    const timestamp = new Date().getTime()
    const signature = $config.signature
    const newSignature = `clientId=${signature.clientId}&clientKey=${signature.clientKey}&timestamp=${timestamp}`
    const mdSignature = md5(newSignature)
    if(options.method === 'post'){
        console.log(url)
        if (url === '/qrTab/show-fields/save') {
            options = {
                ...options,
                headers:{
                    ...options.headers,
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                data:{
                    ...options.data,
                    timestamp:timestamp,
                    sign: mdSignature
                }
            }
        } else {
            options = {
                ...options,
                headers:{
                    ...options.headers,
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                data:{
                    ...options.data,
                    timestamp:timestamp,
                    sign: mdSignature
                }
            }
            options.data = qs.stringify(options.data)
        }
    } else if(options.method === 'get' || options.method === 'DELETE' || options.method === 'delete') {
        if (url === '/appversion/getLastAppQrCode') {
            options = {
                ...options,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                params: {
                    ...options.params,
                    timestamp: timestamp,
                    sign: mdSignature
                }
            }
        } else {
            options = {
                ...options,
                headers: {
                    ...options.headers,
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                params: {
                    ...options.params,
                    timestamp: timestamp,
                    sign: mdSignature
                }
            }
        }
    }
    return {
        url: configBaseUrl+url,
        options
    };
});


// 作为统一错误处理

const http = extend({
    errorHandler
})
export default http;
